import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsReverseIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.88 11.96L16.72 4.22V19.7L4.88 11.96ZM8 11.96L15.06 16.56V7.36L8 11.96Z" />
    </SvgIcon>
  );
});
